import { render, staticRenderFns } from "./ProfileActivity.vue?vue&type=template&id=1938ddd2"
import script from "./ProfileActivity.vue?vue&type=script&lang=js"
export * from "./ProfileActivity.vue?vue&type=script&lang=js"
import style0 from "./ProfileActivity.vue?vue&type=style&index=0&id=1938ddd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports